import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Image } from '@fluentui/react-components';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Collapse,
  useCollapseState,
  getPanelErrorProps
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { ValidatedFormCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';

import { CallToAction } from './call-to-action';
import CallToActionImg from '../media/call-to-action-icon.svg';

export const CollapsibleCallToAction = ({ selectedOption, onDataChange, setNewCTACallback }) => {
  const i18n = useContext(I18nContext);

  const [
    callToActionSection,
    callToActionExpandedSection,
    setCallToActionExpandedSection,
  ] = useCollapseState(['call-to-action'], ['call-to-action']);

  return (
    <Collapse
      allPanelItems={callToActionSection}
      checkItems
      skipItemsTypeCheck
      activeKeys={callToActionExpandedSection}
      setActiveKeys={setCallToActionExpandedSection}
    >
      <ValidatedFormCard
        key="call-to-action"
        className="call-to-action-card"
        attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      >
        <FormCardBasicHeader
          title={i18n.getString(_TL_('Call to action'))}
          helpTopic="pop_BA_PMAX_CallToAction"
          helpLabel={i18n.getString(_TL_('Click to learn more about call to action'))}
          contentBefore={<Image src={CallToActionImg} aria-hidden />}
        />
        <FormCardBody>
          <CallToAction
            selectedOption={selectedOption}
            onDataChange={onDataChange}
            setNewCTACallback={setNewCTACallback}
          />
        </FormCardBody>
      </ValidatedFormCard>
    </Collapse>
  );
};

CollapsibleCallToAction.propTypes = {
  selectedOption: PropTypes.string.isRequired,
  onDataChange: PropTypes.func.isRequired,
  setNewCTACallback: PropTypes.func,
};

CollapsibleCallToAction.defaultProps = { setNewCTACallback: null };
